var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-vertical',{ref:"vertical",scopedSlots:_vm._u([{key:"navbar",fn:function(ref){
var toggleVerticalMenuActive = ref.toggleVerticalMenuActive;
return [_c('navbar',{attrs:{"toggle-vertical-menu-active":toggleVerticalMenuActive},on:{"update-menu":_vm.updateComponentMenu}})]}}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }